import React from 'react';
import InlineSpinner from '../InlineSpinner';
import {
  BTN_DANGER,
  BTN_DARK,
  BTN_GHOST,
  BTN_ICON,
  BTN_PRIMARY,
  BTN_PRIMARY_SM,
  BTN_SECONDARY,
  BTN_SECONDARY_SM,
} from './uiTokens';
import type { ButtonVariant, ButtonSize } from './types/UITypes';
import type { ButtonProps } from './types/UIProps';

export type { ButtonVariant, ButtonSize };

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: BTN_PRIMARY,
  secondary: BTN_SECONDARY,
  ghost: BTN_GHOST,
  danger: BTN_DANGER,
  dark: BTN_DARK,
  icon: BTN_ICON,
};

const VARIANT_SM_CLASS: Partial<Record<ButtonVariant, string>> = {
  primary: BTN_PRIMARY_SM,
  secondary: BTN_SECONDARY_SM,
};

export type { ButtonProps };

export function Button({
  variant = 'secondary',
  size = 'md',
  loading = false,
  className = '',
  disabled,
  children,
  type = 'button',
  ...rest
}: ButtonProps): React.ReactElement {
  const base =
    size === 'sm' && VARIANT_SM_CLASS[variant]
      ? VARIANT_SM_CLASS[variant]!
      : VARIANT_CLASS[variant];

  return (
    <button
      type={type}
      className={`${base} ${className}`.trim()}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <InlineSpinner /> : children}
    </button>
  );
}
